import React from 'react';
import { ArrowDataTransferHorizontalIcon } from 'hugeicons-react';
import '../../Styles/Layout/Resources/Buttons/CodeDiffButton.css';

interface CodeDiffButtonProps {
  showDiff: boolean;
  setShowDiff: (show: boolean) => void;
}

export const CodeDiffButton: React.FC<CodeDiffButtonProps> = ({ showDiff, setShowDiff }) => (
  <button
    type="button"
    className={`code-diff-toggle${showDiff ? ' active' : ''}`}
    onClick={() => setShowDiff(!showDiff)}
    aria-pressed={showDiff}
    aria-label={showDiff ? 'Hide changes' : 'Show changes'}
    title={showDiff ? 'Hide changes' : 'Show changes vs. previous version'}
  >
    <ArrowDataTransferHorizontalIcon size={14} />
    <span className="code-diff-toggle-label">Diff</span>
  </button>
);
